export const ORG_TYPES = {
    NON_PROFIT: 'NON_PROFIT',
    BUSINESS: 'BUSINESS',
};
